


















import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { AttributesDict } from "@/data/Furniture";
import Attributes from "@/data/furniture/Attributes";

@Component
export default class AttributeQuestions extends Vue {
  @Prop()
  readonly value!: Attributes;

  @Prop({ default: false })
  readonly readonly!: boolean;

  readonly attributesDict = AttributesDict;

  readonly attributesKeys = Object.keys(AttributesDict);

  updateAttributes(attr: string, value: string): void {
    const newAttr: Attributes = { ...this.value, [attr]: value === "true" };
    this.$emit("input", newAttr);
  }
}
